import React from "react";
import { Chip, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { useDateUtils } from "../../../utils/formatTime";
import CustomNoRowsOverlay from "../../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";

export default function NewEnquiryComp({
  selectedFilter,
  SelectedData,

  monthName,
  selectedYear,
  fromDate,
  toDate,
}) {
  const { currentMonthName, lastMonthName, weekRange, currentYear } =
    useDateUtils();
  let currentDate = new Date().toISOString().split("T")[0];
  const userRole=localStorage.getItem('userRole')

  const columns = [
    {
      field: "enquiry_name",
      headerName: "Enquiry Name",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.first_name || ""} ${params?.row?.last_name || ""}`,
      renderCell: (params) => (
        <div
          style={{
            color: "#0096FF",

            cursor: "pointer",
            "&:hover": {
              textDecoration: "none",
            },
          }}
          onClick={() =>
            window.open(`/enquirydetails/${params?.row?.id}`, "_blank")
          }
        >
          {params?.row?.first_name} {params?.row?.last_name}
        </div>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.mobile || "",
      renderCell: (params) => <div>{params.row?.mobile_country_code}

      {userRole === "advisor" || userRole === "trainer"
        ? params.row?.mobile?.replace(/.(?=.{4,}$)/g, "*")
        : params.row?.mobile}</div>,
    },

    {
      field: "email",
      headerName: "Email",
      width: 250,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.email || ""}`,
      renderCell: (params) => {
        const email = params.row?.email || "";
    
        if (email.length <= 5) return email; // not enough to mask
    
        const start = email.slice(0, 3);
        const end = email.slice(-3);
        return `${start}***${end}`;
      },
    },
    {
      field: "service",
      headerName: "Service",
      flex: 1,
      minWidth: 200,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.service_id?.service_name || "",
      renderCell: (params) => (
        <div>{params?.row?.service_id?.service_name}</div>
      ),
    },
    {
      field: "sub_service",
      headerName: "Sub Service",
      flex: 1,
      minWidth: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.sub_service_id?.name || "",
      renderCell: (params) => <div>{params?.row?.sub_service_id?.name}</div>,
    },

    {
      field: "prospective_level",
      headerName: "Prospective Level",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params?.row?.prospective_level_id?.prospective_level || "",
      renderCell: (params) => (
        <div>{params?.row?.prospective_level_id?.prospective_level}</div>
      ),
    },
    {
      field: "stage",
      headerName: "Stage",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.stage_id?.stage_name || "",
      renderCell: (params) => <div>{params?.row?.stage_id?.stage_name}</div>,
    },
    {
      field: "assign_to",
      headerName: "Assign To",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.assign_to?.first_name || "",
      renderCell: (params) => (
        <div>
          {params?.row?.assign_to?.first_name}{" "}
          {params?.row?.assign_to?.last_name}
        </div>
      ),
    },
  ];
  return (
    <>
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {selectedFilter === "default" && (
              <Typography variant="h4" textAlign="center">
                {monthName} {selectedYear}
              </Typography>
            )}
            {selectedFilter === "today" && (
              <Typography variant="h4" textAlign="center">
                Today ({currentDate})
              </Typography>
            )}
            {selectedFilter === "currentweek" && (
              <Typography variant="h4" textAlign="center">
                This Week ({weekRange})
              </Typography>
            )}

            {selectedFilter === "currentmonth" && (
              <Typography variant="h4" textAlign="center">
                {currentMonthName} {currentYear}
              </Typography>
            )}

            {selectedFilter === "custom" && (
              <Typography variant="h4" textAlign="center">
                {fromDate} - {toDate}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <DataGrid
              rows={SelectedData}
              columns={columns}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              autoHeight
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              pageSizeOptions={[25, 50, 100]}
            />
          </Grid>
        </Grid>
      </>
    </>
  );
}
